import { UseQueryResult } from "@tanstack/react-query";
import { GroupedPermissions, RoleItem } from "../type";
import { Avatar, Badge, Typography } from "@/components/kit";
import Spinner from "@material-tailwind/react/components/Spinner";
import { useEffect, useState } from "react";
import { addIsEnableIfMissing } from "../util/addIsEnableIfMissing";
import { groupPermissionsByCategory } from "../util/groupPermissionsByCategory";
import PermissionsOverview from "../components/PermissionsOverview";
import SvgIcon from "@/components/common/SvgIcon";
import { useGetPermissionsRoles } from "@/hooks/query/acl/useGetPermissionsRoles";
import { TrioRole } from "@/hooks/query/acl/useGetRoles";

type TProps = {
  selectedRole: TrioRole;
  onClose: () => void;
  EmployeeCount: UseQueryResult<
    {
      items: RoleItem[];
    },
    Error
  >;
};

function RolePermissions({ selectedRole }: TProps) {
  const permissionsRoles = useGetPermissionsRoles({
    roleId: selectedRole.name,
  });
  const [groupedPermissions, setGroupedPermissions] =
    useState<GroupedPermissions>();

  useEffect(() => {
    if (permissionsRoles.data?.permissions) {
      const role = addIsEnableIfMissing(permissionsRoles.data.permissions);
      const init = groupPermissionsByCategory(role);
      setGroupedPermissions(JSON.parse(JSON.stringify(init)));
    }
  }, [permissionsRoles.isSuccess]);

  return (
    <div className="flex flex-col gap-2 px-5">
      <div className="rounded-[12px] bg-gray-50 border border-gray-50 shadow-[1px_1px_8px_0px_rgba(0,0,0,0.08)] p-4 flex justify-between items-center">
        {/* role name  */}
        <div className="flex gap-4 items-center ">
          <Avatar
            size="lg"
            name={selectedRole.name}
            displayedWordAmount={2}
            fontFamily="Title4-Regular"
          />
          <div className="flex flex-col gap-1">
            <Typography variant="Title3-Bold">{selectedRole?.name}</Typography>
            <Typography variant="Caption1-Regular" color="text-gray-400">
              Customized role
            </Typography>
          </div>
        </div>

        {/* role action  */}
        <div>
          <Badge size="sm" state="warning">
            <div className="flex gap-1 items-center">
              <SvgIcon
                iconName="infoFill"
                fill="fill-orange-500"
                className="w-3 h-3"
              />
              <span>Can not be edited</span>
            </div>
          </Badge>
        </div>
      </div>
      {permissionsRoles.isLoading ? (
        <div className="w-full h-full flex items-center justify-center min-h-[300px]">
          <Spinner />
        </div>
      ) : (
        ""
      )}

      {permissionsRoles.isSuccess && (
        <PermissionsOverview
          groupedPermissions={groupedPermissions ?? {}}
          setGroupedPermissions={setGroupedPermissions}
          isEditable={false}
        />
      )}
    </div>
  );
}

export default RolePermissions;
